/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const thirdPartyEnumsHowWasTheIncidentDetectedOptionEnum = {
    SupplierNotification: 'SupplierNotification',
    InternalMonitoring: 'InternalMonitoring',
    CustomerReport: 'CustomerReport',
    PublicDisclosure: 'PublicDisclosure',
    Other: 'Other',
} as const;

export type ThirdPartyEnumsHowWasTheIncidentDetectedOptionEnumKey =
    (typeof thirdPartyEnumsHowWasTheIncidentDetectedOptionEnum)[keyof typeof thirdPartyEnumsHowWasTheIncidentDetectedOptionEnum];

export type ThirdPartyEnumsHowWasTheIncidentDetectedOption = ThirdPartyEnumsHowWasTheIncidentDetectedOptionEnumKey;
